import { render, staticRenderFns } from "./ysf.vue?vue&type=template&id=9af75c1a&scoped=true&"
import script from "./ysf.vue?vue&type=script&lang=js&"
export * from "./ysf.vue?vue&type=script&lang=js&"
import style0 from "./ysf.vue?vue&type=style&index=0&id=9af75c1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af75c1a",
  null
  
)

export default component.exports